export default function getUserRole(me) {
  if (!me) {
    return null;
  }

  if (me.is_super) {
    return 'superAdmin';
  }

  return me?._roles?.[0]?.access?.[0]?.object_type;
}
